import { WagmiProvider, createConfig, http } from "wagmi";
import { mainnet,sepolia,bscTestnet, bsc } from "wagmi/chains";
import { QueryClient, QueryClientProvider } from "@tanstack/react-query";
import { ConnectKitProvider, getDefaultConfig } from "connectkit";
import AppContext from "../context/appContext";
import { useHistory } from "react-router-dom/cjs/react-router-dom.min";
import { useContext } from "react";
const config = createConfig(
  getDefaultConfig({
    // Your dApps chains
    chains: [bsc],
    transports: {
      // RPC URL for each chain
      [bsc.id]: http("https://bsc-dataseed.binance.org/"), // Official BSC RPC
    },

    // Required API Keys
    walletConnectProjectId: "f3c7012da9cbbfb2a0c0382d84c32c04",

    // Required App Info
    appName: "SFT: Staking Focused Token",

    // Optional App Info
    appDescription: "SFT (Staking Focused Token) is a crypto project built for rewarding long-term holders. It offers a secure and efficient staking mechanism, ensuring sustainable growth and passive income for investors.",
    appUrl: "https://sft.com.pk", // your app's url
    appIcon: "https://family.co/logo.png", // your app's icon, no bigger than 1024x1024px (max. 1MB)
  }),
);

const queryClient = new QueryClient();

export const Web3Provider = ({ children }) => {
  const appContext = useContext(AppContext)
    const history = useHistory()
    const { authToken, createAccount, setAuthToken, getUser, userData,setUserData } = appContext
  return (
    <WagmiProvider config={config}>
      <QueryClientProvider client={queryClient}>
        <ConnectKitProvider onDisconnect={()=>{setAuthToken(null);setUserData(null)}}>{children}</ConnectKitProvider>
      </QueryClientProvider>
    </WagmiProvider>
  );
};